import { TFunction } from '@lyearn/i18n';
import { SortAndFilterItem } from '@/components/FilterManager/types';

export const getSelectSkillDialogSortAndFilterItems = (_: TFunction): SortAndFilterItem[] => [];
